import React from "react"

import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "./_base/TwoColumnHeroWithImageRight"

import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

import * as supplyFocusHeroSection from "../styles/SupplyFocusHeroSection.module.css"

export default function SupportHeroSection(props) {
  const { content } = props

  const titleNode = content.childNodes.filter(
    node => node.classNames === "supplyfocus-title"
  )[0]
  const title = (titleNode && titleNode.innerHTML) || ""

  const textStack = content.childNodes
    .filter(node => node.classNames === "supplyfocus-content")
    .map(t => t.text)

  const cta = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes("supplyfocus-hero-cta")
  )[0]

  const nav = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes("supplyfocus-content-nav")
  )[0]

  return (
    <TwoColumnHeroWithImageRight
      contentClass={supplyFocusHeroSection.content}
      imageHolder={content}
      imageSelector={`supplyfocus-bgimage`}
      imageClass={supplyFocusHeroSection.backgroundImage}
      className={supplyFocusHeroSection.wrapper}
      mode={CONTAINMENT_MODE.normal}
    >
      <h2
        className={supplyFocusHeroSection.title}
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
      <WPImage
        holder={content}
        selector={`supplyfocus-icon`}
        mode={DISPLAY_MODE.inline}
        className={`col-12 ${supplyFocusHeroSection.logo}`}
      />
      {textStack.map((t, idx) => (
        <p className={supplyFocusHeroSection.info} key={idx}>
          {t}
        </p>
      ))}
      <p
        className={supplyFocusHeroSection.nav}
        dangerouslySetInnerHTML={{
          __html: nav,
        }}
      />
      {cta && (
        <div
          className={`${supplyFocusHeroSection.cta}`}
          dangerouslySetInnerHTML={{
            __html: cta,
          }}
        />
      )}
    </TwoColumnHeroWithImageRight>
  )
}
